var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "groupbuy-config" },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "form-container",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c("div", { staticClass: "form-layout" }, [
            _c("div", { staticClass: "form-col form-col-main" }, [
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            基本信息\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "活动名称", prop: "title" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请输入活动名称" },
                          model: {
                            value: _vm.form.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "活动标题", prop: "subTitle" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请输入活动标题" },
                          model: {
                            value: _vm.form.subTitle,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "subTitle", $$v)
                            },
                            expression: "form.subTitle",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "标签", prop: "tag" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "请输入标签" },
                          model: {
                            value: _vm.form.tag,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "tag", $$v)
                            },
                            expression: "form.tag",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "购买模式", prop: "mode" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.mode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "mode", $$v)
                              },
                              expression: "form.mode",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  拼团\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            用户购买资格\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户类型", prop: "userType" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.userType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "userType", $$v)
                              },
                              expression: "form.userType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  新用户\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  老用户\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.userType !== 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "用户级别", prop: "userRank" } },
                          [
                            _c(
                              "div",
                              { staticClass: "user-rank-wrapper" },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.userRankChecked,
                                      callback: function ($$v) {
                                        _vm.userRankChecked = $$v
                                      },
                                      expression: "userRankChecked",
                                    },
                                  },
                                  _vm._l(_vm.userRankOptions, function (rank) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: rank.id,
                                        attrs: { label: rank.id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(rank.name) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: { click: _vm.handleSelectAllUserRanks },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.isAllUserRanksSelected
                                            ? "取消全选"
                                            : "全选"
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "企微用户", prop: "isQwe" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.isQwe,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "isQwe", $$v)
                              },
                              expression: "form.isQwe",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  仅企微用户\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            团长（开团人）限制\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "当日注册" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.launchTodayreg,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "launchTodayreg", $$v)
                              },
                              expression: "form.launchTodayreg",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  需当日注册\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  需非当日注册\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "参与过秒杀" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.launchJioncoupon,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "launchJioncoupon", $$v)
                              },
                              expression: "form.launchJioncoupon",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  需参与过\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  需未参与过\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "订单情况" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.launchUserorder,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "launchUserorder", $$v)
                              },
                              expression: "form.launchUserorder",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  需有订单\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  需无订单\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "企微身份" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.launchUserWw,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "launchUserWw", $$v)
                              },
                              expression: "form.launchUserWw",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  需有企微\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  需无企微\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "团长等级" } }, [
                      _c(
                        "div",
                        { staticClass: "user-rank-wrapper" },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.launchRankChecked,
                                callback: function ($$v) {
                                  _vm.launchRankChecked = $$v
                                },
                                expression: "launchRankChecked",
                              },
                            },
                            _vm._l(_vm.userRankOptions, function (rank) {
                              return _c(
                                "el-checkbox",
                                { key: rank.id, attrs: { label: rank.id } },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(rank.name) +
                                      "\n                  "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: { click: _vm.handleSelectAllLaunchRanks },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.isAllLaunchRanksSelected
                                      ? "取消全选"
                                      : "全选"
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "form-hint" }, [
                            _vm._v("不选则不限等级"),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            团员（参团人）限制\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "当日注册" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.attendTodayreg,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "attendTodayreg", $$v)
                              },
                              expression: "form.attendTodayreg",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  需当日注册\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  需非当日注册\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "参与过秒杀" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.attendJioncoupon,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "attendJioncoupon", $$v)
                              },
                              expression: "form.attendJioncoupon",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  需参与过\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  需未参与过\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "订单情况" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.attendUserorder,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "attendUserorder", $$v)
                              },
                              expression: "form.attendUserorder",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  需有订单\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  需无订单\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "企微身份" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.attendUserWw,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "attendUserWw", $$v)
                              },
                              expression: "form.attendUserWw",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  不限\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  需有企微\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  需无企微\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "团员等级" } }, [
                      _c(
                        "div",
                        { staticClass: "user-rank-wrapper" },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.attendRankChecked,
                                callback: function ($$v) {
                                  _vm.attendRankChecked = $$v
                                },
                                expression: "attendRankChecked",
                              },
                            },
                            _vm._l(_vm.userRankOptions, function (rank) {
                              return _c(
                                "el-checkbox",
                                { key: rank.id, attrs: { label: rank.id } },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(rank.name) +
                                      "\n                  "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: { click: _vm.handleSelectAllAttendRanks },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.isAllAttendRanksSelected
                                      ? "取消全选"
                                      : "全选"
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "form-hint" }, [
                            _vm._v("不选则不限等级"),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            购买内容\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "购买类型", prop: "type" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.isEdit },
                            model: {
                              value: _vm.form.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 4 } }, [
                              _vm._v(
                                "\n                  套券\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 5 } }, [
                              _vm._v(
                                "\n                  单品券\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isEdit
                          ? _c("span", { staticClass: "form-hint" }, [
                              _vm._v("编辑时不可修改"),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "发放内容", required: "" } },
                      [
                        _vm.form.type === 4
                          ? [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择券包",
                                    filterable: "",
                                    size: "small",
                                    disabled: _vm.isEdit,
                                  },
                                  on: { change: _vm.handlePackageChange },
                                  model: {
                                    value: _vm.selectedPackageId,
                                    callback: function ($$v) {
                                      _vm.selectedPackageId = $$v
                                    },
                                    expression: "selectedPackageId",
                                  },
                                },
                                _vm._l(_vm.couponPackagesList, function (pkg) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: pkg.id,
                                      attrs: {
                                        label:
                                          pkg.crmPackageId +
                                          "-" +
                                          pkg.packageName,
                                        value: pkg.id,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "space-between",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(pkg.crmPackageId) +
                                                "-" +
                                                _vm._s(pkg.packageName)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                color: "#8492a6",
                                                "font-size": "12px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  pkg.items
                                                    ? pkg.items.length
                                                    : 0
                                                ) + "张券"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _vm.selectedPackage
                                ? _c("div", { staticClass: "pkg-info-bar" }, [
                                    _c(
                                      "span",
                                      { staticClass: "pkg-info-item" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "pkg-info-label" },
                                          [_vm._v("别名")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "pkg-info-val" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedPackage
                                                  .packageAlias || "-"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedPackage.oldPrice != null
                                      ? _c(
                                          "span",
                                          { staticClass: "pkg-info-item" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "pkg-info-label" },
                                              [_vm._v("原价")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pkg-info-val price-strike",
                                              },
                                              [
                                                _vm._v(
                                                  "¥" +
                                                    _vm._s(
                                                      _vm.selectedPackage
                                                        .oldPrice
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedPackage.price != null
                                      ? _c(
                                          "span",
                                          { staticClass: "pkg-info-item" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "pkg-info-label" },
                                              [_vm._v("购买价")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pkg-info-val price-buy",
                                              },
                                              [
                                                _vm._v(
                                                  "¥" +
                                                    _vm._s(
                                                      _vm.selectedPackage.price
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedPackage.packageDesc
                                      ? _c(
                                          "span",
                                          { staticClass: "pkg-info-item" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "pkg-info-label" },
                                              [_vm._v("描述")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "pkg-info-val" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedPackage
                                                      .packageDesc
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedPackage &&
                              _vm.selectedPackage.items &&
                              _vm.selectedPackage.items.length > 0
                                ? _c("div", { staticClass: "items-area" }, [
                                    _c(
                                      "div",
                                      { staticClass: "items-area-header" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "items-area-title" },
                                          [
                                            _vm._v(
                                              "\n                      券明细\n                      "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "items-area-hint",
                                              },
                                              [
                                                _vm._v(
                                                  "（拼团单价/特惠单价 × 发券数量之和 = 总价）"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.totalPurchasePrice > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "items-area-summary",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      购买价 "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    "¥" +
                                                      _vm._s(
                                                        _vm.formatPrice(
                                                          _vm.totalPurchasePrice
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "summary-sep",
                                                  },
                                                  [_vm._v("|")]
                                                ),
                                                _vm._v(
                                                  "\n                      拼团价 "
                                                ),
                                                _c(
                                                  "b",
                                                  { staticClass: "text-green" },
                                                  [
                                                    _vm._v(
                                                      "¥" +
                                                        _vm._s(
                                                          _vm.formatPrice(
                                                            _vm.totalGroupPrice
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.showSpecialPriceColumn
                                                  ? [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "summary-sep",
                                                        },
                                                        [_vm._v("|")]
                                                      ),
                                                      _vm._v(
                                                        "\n                        特惠价 "
                                                      ),
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "text-orange",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "¥" +
                                                              _vm._s(
                                                                _vm.formatPrice(
                                                                  _vm.totalSpecialPrice
                                                                )
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "coupon-card-list" },
                                      _vm._l(
                                        _vm.selectedPackage.items,
                                        function (item) {
                                          return _c(
                                            "div",
                                            {
                                              key: "item-" + item.id,
                                              staticClass: "coupon-card",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "coupon-card-info",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "coupon-card-name-row",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "coupon-id",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "[" +
                                                              _vm._s(
                                                                item.crmCouponId
                                                              ) +
                                                              "]"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "coupon-name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.couponTitle
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "coupon-card-meta",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "别名：" +
                                                            _vm._s(
                                                              item.couponAlias ||
                                                                "-"
                                                            )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "meta-dot",
                                                        },
                                                        [_vm._v("·")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "发券数量：" +
                                                            _vm._s(item.sendNum)
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "coupon-card-prices",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "price-tag",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "price-tag-label",
                                                        },
                                                        [_vm._v("原价")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "price-tag-value text-gray",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "¥" +
                                                              _vm._s(
                                                                _vm.formatPrice(
                                                                  item.oldPrice !=
                                                                    null
                                                                    ? item.oldPrice
                                                                    : item.money
                                                                )
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      item.sendNum > 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "price-tag-subtotal",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "小计 ¥" +
                                                                  _vm._s(
                                                                    _vm.formatPrice(
                                                                      (item.oldPrice !=
                                                                      null
                                                                        ? item.oldPrice
                                                                        : item.money) *
                                                                        (item.sendNum ||
                                                                          1)
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "price-tag",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "price-tag-label",
                                                        },
                                                        [_vm._v("购买价")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "price-tag-value text-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "¥" +
                                                              _vm._s(
                                                                _vm.formatPrice(
                                                                  _vm
                                                                    .itemPurchasePrices[
                                                                    item.id
                                                                  ] || 0
                                                                )
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      item.sendNum > 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "price-tag-subtotal",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "小计 ¥" +
                                                                  _vm._s(
                                                                    _vm.formatPrice(
                                                                      (_vm
                                                                        .itemPurchasePrices[
                                                                        item.id
                                                                      ] || 0) *
                                                                        (item.sendNum ||
                                                                          1)
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "price-tag price-tag-editable price-tag-group",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "price-tag-label",
                                                        },
                                                        [_vm._v("拼团单价")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("el-input-number", {
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                        attrs: {
                                                          precision: 2,
                                                          step: 0.1,
                                                          min: 0,
                                                          controls: false,
                                                          size: "mini",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .itemGroupUnitPrices[
                                                              item.id
                                                            ],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.itemGroupUnitPrices,
                                                              item.id,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "itemGroupUnitPrices[item.id]",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      item.sendNum > 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "price-tag-subtotal",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "小计 ¥" +
                                                                  _vm._s(
                                                                    _vm.formatPrice(
                                                                      (_vm
                                                                        .itemGroupUnitPrices[
                                                                        item.id
                                                                      ] || 0) *
                                                                        (item.sendNum ||
                                                                          1)
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.showSpecialPriceColumn
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "price-tag price-tag-editable",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "price-tag-label",
                                                            },
                                                            [_vm._v("特惠单价")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticStyle: {
                                                                width: "100px",
                                                              },
                                                              attrs: {
                                                                precision: 2,
                                                                step: 0.1,
                                                                min: 0,
                                                                controls: false,
                                                                size: "mini",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .itemSpecialUnitPrices[
                                                                    item.id
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.itemSpecialUnitPrices,
                                                                      item.id,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "itemSpecialUnitPrices[item.id]",
                                                              },
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          item.sendNum > 1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "price-tag-subtotal",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "小计 ¥" +
                                                                      _vm._s(
                                                                        _vm.formatPrice(
                                                                          (_vm
                                                                            .itemSpecialUnitPrices[
                                                                            item
                                                                              .id
                                                                          ] ||
                                                                            0) *
                                                                            (item.sendNum ||
                                                                              1)
                                                                        )
                                                                      )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : !_vm.selectedPackageId
                                ? _c("div", { staticClass: "empty-tip" }, [
                                    _vm._v(
                                      "\n                  请先选择券包\n                "
                                    ),
                                  ])
                                : _c("div", { staticClass: "empty-tip" }, [
                                    _vm._v(
                                      "\n                  该券包暂无明细\n                "
                                    ),
                                  ]),
                            ]
                          : [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择优惠券",
                                    filterable: "",
                                    clearable: "",
                                    disabled: _vm.isEdit,
                                  },
                                  on: { change: _vm.handleCouponChange },
                                  model: {
                                    value: _vm.selectedCouponId,
                                    callback: function ($$v) {
                                      _vm.selectedCouponId = $$v
                                    },
                                    expression: "selectedCouponId",
                                  },
                                },
                                _vm._l(_vm.bonusList, function (bonus) {
                                  return _c("el-option", {
                                    key: bonus.typeId,
                                    attrs: {
                                      label:
                                        "[" +
                                        bonus.typeId +
                                        "] " +
                                        bonus.typeName,
                                      value: bonus.typeId,
                                    },
                                  })
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _vm.selectedCoupon
                                ? _c(
                                    "div",
                                    { staticClass: "single-coupon-prices" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "price-input-group" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "price-input-label",
                                            },
                                            [_vm._v("市场价")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "130px" },
                                            attrs: {
                                              precision: 2,
                                              step: 0.1,
                                              min: 0,
                                              size: "small",
                                            },
                                            model: {
                                              value: _vm.form.marketMoney,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "marketMoney",
                                                  $$v
                                                )
                                              },
                                              expression: "form.marketMoney",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "price-input-unit" },
                                            [_vm._v("元")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "price-input-group" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "price-input-label",
                                            },
                                            [_vm._v("购买价")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "130px" },
                                            attrs: {
                                              precision: 2,
                                              step: 0.1,
                                              min: 0,
                                              size: "small",
                                            },
                                            model: {
                                              value: _vm.form.money,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "money", $$v)
                                              },
                                              expression: "form.money",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "price-input-unit" },
                                            [_vm._v("元")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "price-input-group is-group",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "price-input-label",
                                            },
                                            [_vm._v("拼团价")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "130px" },
                                            attrs: {
                                              precision: 2,
                                              step: 0.1,
                                              min: 0,
                                              size: "small",
                                            },
                                            model: {
                                              value: _vm.form.groupMoney,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "groupMoney",
                                                  $$v
                                                )
                                              },
                                              expression: "form.groupMoney",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "price-input-unit" },
                                            [_vm._v("元")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.specialPriceConditionMet
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "price-input-group is-special",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "price-input-label",
                                                },
                                                [_vm._v("特惠价")]
                                              ),
                                              _vm._v(" "),
                                              _c("el-input-number", {
                                                staticStyle: { width: "130px" },
                                                attrs: {
                                                  precision: 2,
                                                  step: 0.1,
                                                  min: 0,
                                                  size: "small",
                                                },
                                                model: {
                                                  value: _vm.form.specialMoney,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "specialMoney",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.specialMoney",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "price-input-unit",
                                                },
                                                [_vm._v("元")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _c("div", { staticClass: "empty-tip" }, [
                                    _vm._v(
                                      "\n                  请选择优惠券并设置价格\n                "
                                    ),
                                  ]),
                            ],
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            其他设置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "购买时间", prop: "timeRange" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetimerange",
                            "range-separator": "至",
                            "start-placeholder": "开始时间",
                            "end-placeholder": "结束时间",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          model: {
                            value: _vm.timeRange,
                            callback: function ($$v) {
                              _vm.timeRange = $$v
                            },
                            expression: "timeRange",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否生效", prop: "enabled" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "有效",
                            "inactive-text": "无效",
                          },
                          model: {
                            value: _vm.form.enabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "enabled", $$v)
                            },
                            expression: "form.enabled",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "过期天数", prop: "expired" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 0 },
                          model: {
                            value: _vm.form.expired,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "expired", $$v)
                            },
                            expression: "form.expired",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form-hint" }, [
                          _vm._v("活动结束后多少天过期"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "说明信息", prop: "notice" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "textarea",
                            rows: 6,
                            placeholder: "请输入说明信息",
                          },
                          model: {
                            value: _vm.form.notice,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "notice", $$v)
                            },
                            expression: "form.notice",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-col form-col-side" }, [
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            库存\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "库存数", prop: "totalNum" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            min: _vm.isEdit ? _vm.originalTotalNum || 0 : 0,
                          },
                          model: {
                            value: _vm.form.totalNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "totalNum", $$v)
                            },
                            expression: "form.totalNum",
                          },
                        }),
                        _vm._v(" "),
                        _vm.isEdit
                          ? _c("span", { staticClass: "form-hint" }, [
                              _vm._v(
                                "当前：" +
                                  _vm._s(_vm.originalTotalNum) +
                                  "，只能增不能减"
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "每人限购", prop: "prePeopleNum" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 1 },
                          model: {
                            value: _vm.form.prePeopleNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "prePeopleNum", $$v)
                            },
                            expression: "form.prePeopleNum",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            图片设置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "封面图", prop: "imgUrl" } },
                      [
                        _c("image-upload", {
                          attrs: { limit: 1 },
                          model: {
                            value: _vm.form.imgUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "imgUrl", $$v)
                            },
                            expression: "form.imgUrl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "列表图", prop: "coverImgUrl" } },
                      [
                        _c("image-upload", {
                          attrs: { limit: 1 },
                          model: {
                            value: _vm.form.coverImgUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "coverImgUrl", $$v)
                            },
                            expression: "form.coverImgUrl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "简介图", prop: "introImgUrl" } },
                      [
                        _c("image-upload", {
                          attrs: { limit: 1 },
                          model: {
                            value: _vm.form.introImgUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "introImgUrl", $$v)
                            },
                            expression: "form.introImgUrl",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            分享设置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "可否分享", prop: "canShare" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": true,
                            "inactive-value": false,
                            "active-text": "可分享",
                            "inactive-text": "不可分享",
                          },
                          model: {
                            value: _vm.form.canShare,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "canShare", $$v)
                            },
                            expression: "form.canShare",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "分享标题", prop: "shareTitle" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请输入分享标题" },
                          model: {
                            value: _vm.form.shareTitle,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shareTitle", $$v)
                            },
                            expression: "form.shareTitle",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "分享图", prop: "shareImgUrl" } },
                      [
                        _c("image-upload", {
                          attrs: { limit: 1 },
                          model: {
                            value: _vm.form.shareImgUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shareImgUrl", $$v)
                            },
                            expression: "form.shareImgUrl",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            拼团设置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "拼团价", prop: "groupMoney" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { precision: 2, step: 0.1, min: 0 },
                          on: { change: _vm.handleGroupMoneyChange },
                          model: {
                            value: _vm.form.groupMoney,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "groupMoney", $$v)
                            },
                            expression: "form.groupMoney",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form-hint" }, [
                          _vm._v("元（团长与团员同价）"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    false
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "成团人数", prop: "lbNum" } },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "200px" },
                              attrs: { min: 2, max: 100, disabled: "" },
                              model: {
                                value: _vm.form.lbNum,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "lbNum", $$v)
                                },
                                expression: "form.lbNum",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "form-hint" }, [
                              _vm._v("人（最少2人，固定为2人）"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "有效时长", prop: "lbTime" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 1, max: 10080 },
                          model: {
                            value: _vm.form.lbTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "lbTime", $$v)
                            },
                            expression: "form.lbTime",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form-hint" }, [
                          _vm._v("分钟"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "每人限购", prop: "prePeopleLbNum" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 1, max: 99 },
                          model: {
                            value: _vm.form.prePeopleLbNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "prePeopleLbNum", $$v)
                            },
                            expression: "form.prePeopleLbNum",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form-hint" }, [
                          _vm._v("次"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            特惠设置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c("div", { staticClass: "sp-toggles" }, [
                      _c(
                        "div",
                        { staticClass: "sp-toggle" },
                        [
                          _c("span", { staticClass: "sp-toggle-label" }, [
                            _vm._v("当日注册特惠"),
                          ]),
                          _vm._v(" "),
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.form.todayreg,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "todayreg", $$v)
                              },
                              expression: "form.todayreg",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sp-toggle" },
                        [
                          _c("span", { staticClass: "sp-toggle-label" }, [
                            _vm._v("参与过秒杀特惠"),
                          ]),
                          _vm._v(" "),
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.form.jioncoupon,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "jioncoupon", $$v)
                              },
                              expression: "form.jioncoupon",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sp-toggle" },
                        [
                          _c("span", { staticClass: "sp-toggle-label" }, [
                            _vm._v("产生过消费单特惠"),
                          ]),
                          _vm._v(" "),
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.form.userorder,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "userorder", $$v)
                              },
                              expression: "form.userorder",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.specialPriceConditionMet &&
                    (_vm.form.type === 4 || _vm.form.type === 5)
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "sp-price-item",
                            attrs: { label: "特惠价格", "label-width": "80px" },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "160px" },
                              attrs: { precision: 2, step: 0.1, min: 0 },
                              on: { change: _vm.handleSpecialMoneyChange },
                              model: {
                                value: _vm.form.specialMoney,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "specialMoney", $$v)
                                },
                                expression: "form.specialMoney",
                              },
                            }),
                            _vm._v(" "),
                            _vm.form.type === 4
                              ? _c("span", { staticClass: "form-hint" }, [
                                  _vm._v("修改后将按比例分配到各券明细"),
                                ])
                              : _c("span", { staticClass: "form-hint" }, [
                                  _vm._v("单品券特惠价，直接输入即可"),
                                ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("\n        保存\n      ")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("\n        取消\n      "),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }